const GTMDataLayer = (props) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: props.clickEvent,
      question: props.question,
      answer: props.answer,
      leadID: props.leadID,
      CreditCheck: props.CreditCheck,
      rel_agreement_count: props.rel_agreement_count,
      rel_agreement_count_self: props.rel_agreement_count_self,
      email: props.email,
      phone: props.phone,
      brand: props.brand,
      account: props.account,
    });

  return <></>;
};

export default GTMDataLayer;
